import { render, staticRenderFns } from "./deadline-cell.vue?vue&type=template&id=43e2b21a&scoped=true&"
import script from "./deadline-cell.vue?vue&type=script&lang=js&"
export * from "./deadline-cell.vue?vue&type=script&lang=js&"
import style0 from "./deadline-cell.vue?vue&type=style&index=0&id=43e2b21a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e2b21a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43e2b21a')) {
      api.createRecord('43e2b21a', component.options)
    } else {
      api.reload('43e2b21a', component.options)
    }
    module.hot.accept("./deadline-cell.vue?vue&type=template&id=43e2b21a&scoped=true&", function () {
      api.rerender('43e2b21a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-table/violations/deadline-cell.vue"
export default component.exports